"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMarylandRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateCode = 'MD';

function getMarylandRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Perpetual Care Trust Fund',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Bus. Reg.] § 5-603',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PERPETUAL_CARE_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Unpaid Wages',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Md. Code Ann., [Com. Law] § 15-601.1; Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (e)',
    limitAggregateSingle: 145,
    limitAggregateJoint: 290,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnership property',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Corps. & Ass\'ns] §9A-502; Md. Code Ann., [Cts. & Jud. Proc.] 9A-504 (a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PARTNERSHIP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Crime Victim Compensation',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Crim. Proc.] § 11-816 (b)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Alimony (to the same extent wages are exempt)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (7)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.ALIMONY];
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tools of Trade',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(1)',
    limitAggregateSingle: 5000,
    limitAggregateJoint: 10000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.TOOLS_OF_TRADE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Disability or Health Benefits',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (tertiaryType === _tertiaryTypes.DISABILITY_BENEFITS || tertiaryType === _tertiaryTypes.HEALTH_BENEFITS);
    }
  }, {
    id: idCounter.increment(),
    description: 'Lost Earnings Recovery',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.LOSS_OF_FUTURE_EARNINGS_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Health Aids',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(3)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'Household Goods, Electronics, Books, Equipment for sports and hobbies, Clothing, and Pets',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(4)',
    limitAggregateSingle: 1000,
    limitAggregateJoint: 2000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubtypes = [_subTypes.HOUSEHOLD, _subTypes.ELECTRONICS, _subTypes.BOOK, _subTypes.SPORTS_OR_HOBBY_EQUIPMENT, _subTypes.CLOTHES, _subTypes.PERSONAL_ANIMALS];
      return this.canTakeMoreExemptions() && validSubtypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Cash (claimed within Thirty Days of levy)',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(5)',
    limitAggregateSingle: 6000,
    limitAggregateJoint: 12000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CASH;
    }
  }, {
    id: idCounter.increment(),
    description: 'Child Support',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CHILD_SUPPORT;
    }
  }, {
    id: idCounter.increment(),
    description: 'ERISA Benefits and IRAs',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (h)(1)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.IRA || tertiaryType === _tertiaryTypes.ERISA_REITREMENT_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'Prepaid College Trust',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Educ.] § 18-1913',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.PREPAID_COLLEGE_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Assistance',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Human Serv. Art.] § 5-407(a)(1),(2)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PUBLIC_ASSISTANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (Beneficiary is Dependent)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Md. Code Ann., [Ins.] § 16-111 (a)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Ins.] § 8-431; Md. Code Ann., [Est. & Trusts] § 8-115',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Lab. & Empl.] § 8-106',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Workers Compensation',
    type: stateCode,
    statuteName: 'Md. Code Ann., [Lab. & Empl.] § 9-732',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'State Employee Retirement',
    type: stateCode,
    statuteName: 'Md. Code Ann., [State Pers. & Pen.] § 21-502',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.STATE_EMPLOYEES_PENSION;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    type: stateCode,
    description: 'Wildcard',
    statuteName: 'Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (b)(5); Md. Code Ann., [Cts. & Jud. Proc.] § 11-504 (f)(1)(i)(1)',
    limitAggregateSingle: 11000,
    limitAggregateJoint: 22000,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}